import { useState } from 'react';

export const useCalculator = ({ showMulchOptions, unitsPerCase, addAdditional, calculatorType }) => {
  const [calculate, setCalculate] = useState({
    calcByArea: false,
    calcByWidthHeight: true,
    hasError: false,
    isClicked: false,
    overlayOpened: false,
    quantity: 0,
    bulkQuantity: 0,
    step: 1,
    toggleText: 'Calculate by Square Footage',
    mulchType: 'wood',
    bagSize: '1.5',
    value: '',
    valueAreas: [{ value: '', changed: false }],
    valueDescription: [''],
    valueWidths: [''],
    valueHeights: [''],
    valueDepths: ['3'],
  });

  const addElement = () => {
    setCalculate((prevState) => {
      const {
        calcByWidthHeight,
        calcByArea,
        valueAreas,
        valueDescription,
        valueHeights,
        valueWidths,
        valueDepths,
        step
      } = prevState;
      if (calculatorType === 'Volume') {
        valueDepths.push('3');
      }
      if (calcByWidthHeight) {
        valueHeights.push('');
        valueWidths.push('');
      } else if (calcByArea) valueAreas.push({ value: '', changed: false });
      return {
        ...calculate,
        hasError: false,
        step: step + 1,
        valueDescription,
        valueHeights,
        valueWidths,
        valueAreas,
        valueDepths
      };
    });
  };

  const getDepthValue = (depthIndex) => {
    const { valueDepths } = calculate;
    let depthValue = 1;
    if (calculatorType === 'Volume') {
      depthValue = parseInt(valueDepths[depthIndex], 10) / 12;
    }
    return Number.isNaN(depthValue) ? 1 : depthValue;
  };

  const calculateTotal = () => {
    const {
      isClicked,
      valueDescription,
      bagSize,
      mulchType,
      valueHeights,
      valueWidths,
      calcByArea,
      calcByWidthHeight,
      valueAreas
    } = calculate;
    const units = showMulchOptions ? bagSize : unitsPerCase;
    const sizeValue = +units;
    let quantitys = 0;
    let valueTotal = 0;
    let bulkQuantitys = 0;
    let errorCal = false;
    if (calcByWidthHeight) {
      if (valueHeights.length === valueWidths.length) {
        for (let index = 0; index < valueHeights.length; index += 1) {
          errorCal = errorCal || valueHeights[index] === '' || valueWidths[index] === '';
          valueTotal += valueHeights[index] * valueWidths[index] * getDepthValue(index);
        }
      }
    } else if (calcByArea) {
      for (let index = 0; index < valueAreas.length; index += 1) {
        errorCal = errorCal || valueAreas[index].value === '';
        valueTotal += Number(valueAreas[index].value) * getDepthValue(index);
      }
    }

    if (sizeValue) {
      let updateCoverage = valueTotal;
      if (addAdditional) {
        updateCoverage += (valueTotal * 0.10);
      }
      quantitys = Math.ceil(updateCoverage / sizeValue);
    }

    if (showMulchOptions) {
      const bulkSize = mulchType === 'rubber' ? 38.5 : 5;
      bulkQuantitys = Math.ceil(valueTotal / bulkSize);
    }

    const ret = {
      ...calculate,
      valueDescription,
      mulchType,
      bagSize,
      bulkQuantity: bulkQuantitys,
      quantity: quantitys,
      coverage: valueTotal,
      hasError: errorCal,
      isClicked: true,
    };
    setCalculate(ret);
    return ret;
  };

  return [calculate, { setCalculate, addElement, calculateTotal }];
};
